import { useTranslation } from "@refinedev/core";
import Button from "components/button";
import { IModalProps, Modal } from "components/modal";
import Pagination from "components/pagination";
import { Tag } from "components/tag";
import {
  ApplyToProductType,
  IEventIdsItem,
  IPromotionCouponItem,
  IPromotionEventIdsItem,
} from "interfaces";
import { get } from "lodash";
import { useState } from "react";
import { getApplyToProductTypeLabel, paginate } from "utills/helpers";
interface ICouponInfoModalProps extends IModalProps {
  couponData: {
    event_id: string;
    code: string;
    rule_id: number;
    apply_type: ApplyToProductType;
  }[];
  events: IPromotionEventIdsItem[];
}

const DEFAULT_PAGE_SIZE = 8;

export const CouponAlreadyExistsModal = ({
  onClose,
  open,
  couponData,
  events,
}: ICouponInfoModalProps) => {
  const { translate, getLocale } = useTranslation();
  const [pageNumber, setPageNumber] = useState(1);

  if (!open) {
    return <></>;
  }
  return (
    <Modal
      title="Coupon Code Already Exists"
      onClose={onClose}
      open={open}
      closeOnClickBackdrop={false}
      footer={
        <Button
          className="bg-white border-brand-500 border-[1px] border-solid text-brand-500 hover:bg-white active:opacity-85 active:bg-transparent w-full"
          onClick={onClose}
        >
          <span className="sr-only">Understand</span>
          <span className="ml-2">Understand</span>
        </Button>
      }
    >
      <div className="flex flex-col w-full gap-y-4 divide px-4 py-3.5 text-base sm:max-w-xl">
        <div className="flow-root">
          <div className="relative inline-block w-full align-middle box-border">
            <table className="w-full divide-y divide-gray-300 bg-magnolia-500 rounded-md">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="th py-3.5 pl-4 pr-3 sm:pl-6 lg:pl-8"
                  >
                    No
                  </th>
                  <th scope="col" className="th">
                    Coupon Code
                  </th>
                  <th scope="col" className="th">
                    Created For Event
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200 bg-white">
                {paginate(couponData, pageNumber, DEFAULT_PAGE_SIZE).map(
                  (item, index: number) => {
                    const eventName = get(
                      events.find((event) => event.id === item.event_id),
                      `name_${getLocale()}`,
                      ""
                    );
                    return (
                      <tr key={index}>
                        <td className="td py-4 pl-4 pr-3 sm:pl-6 lg:pl-8">
                          {(pageNumber - 1) * DEFAULT_PAGE_SIZE + 1 + index}
                        </td>
                        <td className="td font-medium">{item.code}</td>
                        <td className="td">
                          {item?.apply_type === ApplyToProductType.ALL
                            ? "All events"
                            : item?.apply_type === ApplyToProductType.INCLUDE
                            ? eventName
                            : item?.apply_type === ApplyToProductType.EXCLUDE
                            ? `All events excluding: ${eventName}`
                            : ""}
                        </td>
                      </tr>
                    );
                  }
                )}
              </tbody>
            </table>
            <p className="mt-4 text-sm">
              Please enter a different code or select other events to proceed.
            </p>
            {couponData.length >= DEFAULT_PAGE_SIZE + 1 ? (
              <div className="mt-6">
                <Pagination
                  hideTotal={true}
                  currentPage={pageNumber}
                  totalPage={Math.ceil(couponData.length / DEFAULT_PAGE_SIZE)}
                  total={{
                    totalItems: couponData.length ?? 0,
                    total: couponData.length ?? 0,
                  }}
                  onChange={(page) => setPageNumber(page)}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
